import { defu } from "defu";
import { defineNuxtPlugin } from "nuxt/app";

export default defineNuxtPlugin({
  name: "ckweb:custom-config",
  enforce: "pre",
  dependsOn: ["ckweb:settings", "ckweb:dev-console"],
  async setup($nuxt) {
    const config = useRuntimeConfig();
    const authOptions = defu(
      {
        hygiena: {
          appName: config.public.HYGIENA_AUTH_SELF_SERVICE_APP_NAME,
          baseUrl: config.public.HYGIENA_AUTH_URL,
          attributes: {
            mode: "popup",
            "register-href": "/subscription/select-plan",
            "forgot-password-href": "/forgot-password",
            "username-placeholder": () => $nuxt.$i18n.t("auth.enterUsername"),
            "password-placeholder": () => $nuxt.$i18n.t("auth.enterPassword"),
          },
          labels: {
            "forgot-password-label": () =>
              $nuxt.$i18n.t("auth.forgotUsernameOrPassword"),
            "submit-label": () => $nuxt.$i18n.t("auth.submitLabel"),
            "register-prompt-label": () =>
              $nuxt.$i18n.t("auth.registerPromptLabel"),
            "register-label": () => $nuxt.$i18n.t("auth.registerLabel"),
          },
        },
      },
      config.public.AUTH_OPTIONS,
    );

    config.public.AUTH_OPTIONS = authOptions;

    devConsole.info("🛠️ ckSetup: custom config applied  🚀🚀🚀🚀🚀");
  },
});
